var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"doh"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.name)+"部署情况")])]),_c('div',{ref:"box",staticClass:"box",attrs:{"id":"box"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }